import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, MessageSquare, CalendarCheck, Scale } from "lucide-react";
import { scrollToId } from "./Header";

const itemClass =
  "flex flex-1 flex-col items-center justify-center gap-1 min-h-[56px] px-1 text-center text-[10px] leading-tight uppercase tracking-[0.1em] transition-colors duration-200";

const FIELD = "input, select, textarea";

const track = (action) => {
  if (typeof window.gtag === "function") {
    window.gtag("event", "mobile_bar_click", {
      event_category: "mobile_action_bar",
      event_label: action,
      bar_action: action,
      page_path: window.location.pathname,
    });
  }
};

const useFormFocus = () => {
  const [focused, setFocused] = useState(false);
  useEffect(() => {
    const onIn = (e) => setFocused(!!e.target.closest?.(FIELD));
    const onOut = (e) => {
      if (!e.relatedTarget?.closest?.(FIELD)) setFocused(false);
    };
    document.addEventListener("focusin", onIn);
    document.addEventListener("focusout", onOut);
    return () => {
      document.removeEventListener("focusin", onIn);
      document.removeEventListener("focusout", onOut);
    };
  }, []);
  return focused;
};

export const MobileActionBar = () => {
  const { pathname } = useLocation();
  const hidden = useFormFocus();
  const book = () => {
    track("free_consultation");
    if (pathname === "/advice-fee-health-check") window.location.href = "/#contact";
    else scrollToId("contact");
  };

  return (
    <>
      <div aria-hidden="true" className="h-[64px] bg-[#0A2333] lg:hidden" />
      <nav
        data-testid="mobile-action-bar"
        data-hidden={hidden}
        aria-label="Quick contact"
        aria-hidden={hidden}
        className={`lg:hidden fixed inset-x-0 bottom-0 z-40 flex bg-[#0A2333] text-[#F9F8F4] border-t border-[#A78558]/40 pb-[env(safe-area-inset-bottom)] transition-transform duration-300 ease-out ${
          hidden ? "translate-y-full pointer-events-none" : "translate-y-0"
        }`}
      >
        <a
          href="tel:+61411842648"
          data-testid="mobile-bar-call"
          onClick={() => track("call")}
          className={`${itemClass} active:bg-white/10`}
        >
          <Phone size={18} className="text-[#A78558]" />
          Call
        </a>
        <a
          href={`sms:+61411842648?&body=${encodeURIComponent(
            pathname === "/advice-fee-health-check"
              ? "Hi Kevin, I would like a free fee health check, here are the fees I currently pay...."
              : "Hi Kevin, I'd like to book a free consultation"
          )}`}
          data-testid="mobile-bar-text"
          onClick={() => track("text")}
          className={`${itemClass} border-l border-white/10 active:bg-white/10`}
        >
          <MessageSquare size={18} className="text-[#A78558]" />
          Text
        </a>
        <button
          type="button"
          data-testid="mobile-bar-book"
          onClick={book}
          className={`${itemClass} border-x border-white/10 bg-[#F9F8F4] text-[#0A2333] active:bg-white`}
        >
          <CalendarCheck size={18} />
          Free consultation
        </button>
        <Link
          to="/advice-fee-health-check"
          data-testid="mobile-bar-fee-check"
          onClick={() => track("fee_health_check")}
          className={`${itemClass} active:bg-white/10`}
        >
          <Scale size={18} className="text-[#A78558]" />
          Fee health check
        </Link>
      </nav>
    </>
  );
};
